import React, { useContext, useEffect, useState } from 'react'
import { 
  Container,
  GridContainer,
  HorizontalHeader,
  VerticalHeader,
  CellInput
} from './style'
import CertificatesContext, { CertificateObject } from '../../../../../../contexts/CertificatesContext'

interface TableProps {
  index: number
  viewMinMax: boolean
  setHasOutOfNorm: React.Dispatch<React.SetStateAction<boolean>>
}

const StructureTable: React.FC<TableProps> = (props) => {
  const { structureData, setStructureData } = useContext(CertificatesContext)
  const structure = structureData[props.index]

  const limitNumbers = Array.from({ length: structure.tableRows.length }, () => Array(structure.tableRows.length).fill(0))

  if (structure?.minTable?.length > 0 || structure?.maxTable?.length > 0){
    for (const i in structure.tableData){
      for (const j in structure.tableData[i]){
        if (structure.tableData[i][j] !== ''){
          const value = Number(structure.tableData[i][j])
          if (structure.minTable[i][j] !== '' && value < Number(structure.minTable[i][j])){
            limitNumbers[i][j] = -1
          } else if (structure.maxTable[i][j] !== '' && value > Number(structure.maxTable[i][j])){
            limitNumbers[i][j] = 1
          }
        }
      }
    }
  }

  useEffect(() => {
    if(structure?.minTable?.length > 0 || structure?.maxTable?.length > 0){
      props.setHasOutOfNorm(hasParametersOutOfNorm())
    }
  }, [structure.tableData])

  const hasParametersOutOfNorm = () => {
    return structure.tableRows.some((_, rowIndex) =>
      structure.tableColumns.some((_, columnIndex) =>
        returnIfItIsNotInTheNorm(rowIndex, columnIndex, structure.tableData[rowIndex][columnIndex]) === 'outsideTheNorm'
      )
    )
  }

  let unit = ''

  switch(structure.format){
    case 'Porcentagem':
      unit = '%'
      break
    case 'Graus':
      unit = '°'
      break
    case 'Nenhum':
      break
    default:
      unit = structure.format
  }

  
  const handleChange = (value: string, rowIndex: number, columnIndex: number) => {
    let numericValue = value.replace(/[^0-9,]/g, '')
  
    const parts = numericValue.split(',')
    if (parts.length > 2) {
      numericValue = parts[0] + ',' + parts.slice(1).join('')
    }
  
    if (numericValue.startsWith('0') && !numericValue.startsWith('0,')) {
      numericValue = numericValue.replace(/^0+/, '0')
    }
  
    const [integerPart, decimalPart] = numericValue.split(',')
    let formattedValue = ''
  
    if (numericValue === '') {
      formattedValue = ''
    } else if (decimalPart !== undefined) {
      formattedValue = `${integerPart || '0'},${decimalPart}`
    } else {
      formattedValue = integerPart
    }
  
    const newData = [...structure.tableData]
    newData[rowIndex][columnIndex] = formattedValue
  
    const newStructures = [...structureData]
    newStructures[props.index].tableData = newData
    setStructureData(newStructures)
  }
  

  const limitInfo = (rowIndex: number, columnIndex: number) => {
    // É possível fazer mais eficientemente esses "ifs" mas aqui a legibilidade é mais importante
    if (structure.minTable[rowIndex][columnIndex] === '' && structure.maxTable[rowIndex][columnIndex] === ''){
      return 'Sem restrições'
    }
    if (structure.minTable[rowIndex][columnIndex] !== '' && structure.maxTable[rowIndex][columnIndex] !== ''){
      return `${structure.minTable[rowIndex][columnIndex]} ≤ Valor ≤ ${structure.maxTable[rowIndex][columnIndex]}`
    }
    if (structure.minTable[rowIndex][columnIndex] !== ''){
      return `${structure.minTable[rowIndex][columnIndex]} ≤ Valor`
    }
    return `Valor ≤ ${structure.maxTable[rowIndex][columnIndex]}`
  }

  const returnIfItIsNotInTheNorm = (row:number, column:number, value:string):string => {
    const valueToNumber = Number(value.replace(',','.'))
    const minToNumber = Number(structure.minTable[row][column].replace(',','.'))
    const maxToNumber = Number(structure.maxTable[row][column].replace(',','.'))

    if(minToNumber && valueToNumber < minToNumber) {
      return 'outsideTheNorm'
    }

    if(maxToNumber && valueToNumber > maxToNumber) {
      return 'outsideTheNorm'
    }

    return ''
  }

  return (
    <Container>
      <GridContainer columnCount={structure.tableColumns.length}>
        <HorizontalHeader></HorizontalHeader>
        {structure.tableColumns.map((column) => (
          <HorizontalHeader key={column}>{column}</HorizontalHeader>
        ))}
        {structure.tableRows.map((row, rowIndex) => (
          <>
            <VerticalHeader key={row}>{row}</VerticalHeader>
            {structure.tableColumns.map((column, columnIndex) => (
              <CellInput
                key={column}
                placeholder={
                  props.viewMinMax ? 
                  limitInfo(rowIndex, columnIndex) : 
                  unit
                }
                value = {props.viewMinMax ? '' : structure.tableData[rowIndex][columnIndex]}
                onChange = {(e) => handleChange(e.target.value, rowIndex, columnIndex)}
                className = {
                  structure.minTable.length !== 0 ? returnIfItIsNotInTheNorm(rowIndex, columnIndex, structure.tableData[rowIndex][columnIndex]) : ''
                }
                />
            ))}
          </>
        ))}
      </GridContainer>
    </Container>
  )
}
export default StructureTable
